<template>
    <div class="competition_wrap pb17 padding_side">
        <div class="competition_item thumbnail_item">
            <div class="competition_input">
                <el-input :placeholder="`${$t('st')}`" v-model="searchInput"
                          @input="setData('searchInput',searchInput)"
                          @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)"></el-input>
                <button class="competition_btn" @click="setFilterFunc(searchInputOption,searchInput)"></button>
            </div>
        </div>
        <div class="competition_btn_wrap">
            <button class="c_sort_btn ma0" @click="openFilter('open-market-sort-filter')"></button>
            <button class="c_filter_btn" @click="openFilter('openmarket-filter-modal')"></button>
            <!--썸네일 원 아이콘-->
            <button class="c_filter_thumnail_btn btn_thumb_one"
                    v-show=" listChange === 'thumbnail_one'"
                    @click="listTypeChange('thumbnail_two')"></button>
            <!--썸네일 투 아이콘      -->
            <button class="c_filter_thumnail_btn"
                    v-show=" listChange === 'thumbnail_two'"
                    @click="listTypeChange('thumbnail_one')"></button>
        </div>
        <div class="clear"></div>
        <openmarket-filter-modal></openmarket-filter-modal>
        <open-market-sort-filter></open-market-sort-filter>
    </div>
</template>


<script>

import itemUtil from "@/components/item/itemUtil";
import util from "@/mixins/util";
import OpenmarketFilterModal from "@/components/modal/OpenmarketFilterModal";
import OpenMarketSortFilter from "@/components/sort/OpenMarketSortFilter";
import EventBus from "@/utils/event-bus";

const {filterConfig} = itemUtil
export default {
    name: "ItemFilterModalOpenMarketLayout",
    mixins: [itemUtil],
    components: {OpenmarketFilterModal, OpenMarketSortFilter},
    inject: ['setFilter', 'setSort'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
            }
        },
        sortData: {
            type: Object,
            default: () => {
            }
        },
    },
    data() {
        return {
            searchInputOption: 'ina',
            sortOption: 'last_update',
            sort: '',
            searchInput: '',
            filterStatus: [],
            filterEdition: [],
            filterType: [],
            priceInput: ['', ''],
            filterCategory: [],
            listChange: 'thumbnail_one',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.setterFilterDataInData();
        if (!util.isEmpty(this.sortData)) {
            this.setterSortDataInData()
        }
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        listTypeChange(type) {
            this.listChange = type;
            EventBus.$emit('changeListType', type);
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setData(key, value) {
            this[key] = value;
        },
        setterSortDataInData() {
            this.sort = this.sortData.order;
            this.sortOption = this.sortData.key
            if (this.sortData.key === 'i_price') {
                if (this.sortData.order === 'desc') {
                    this.sortOption = `priceDesc`
                } else if (this.sortData.order === 'asc') {
                    this.sortOption = `priceAsc`
                }
            }
        },
        sortChange(data) {
            if (data === 'priceAsc') {
                this.sort = 'asc'
                this.setSort('i_price', 'asc');
            } else if (data === 'priceDesc') {
                this.sort = 'desc'
                this.setSort('i_price', 'desc');
            } else {
                this.sort = 'desc'
                this.setSort(data, 'desc');
            }
        },
        changeFilter() {
            if (this.priceInput[1] !== '' && this.priceInput[0] > this.priceInput[1]) {
                return
            }
            this.setFilterFunc('pr', this.priceInput);
        },
        openFilter(name) {
            this.$modal.show(name, {sortData: this.sortData, filterData: this.filterData});
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
